import { getApiUrl, getEnvVar } from "@commons-monorepo/index";
import { camelizeKeys } from "humps";
import { Treatment, TreatmentPayload } from "~/common/props/treatment";

export const fetchTreatment = ({
  ownerId,
  feature,
  country,
  growIdLastDigit,
}: TreatmentPayload): Promise<Treatment> => {
  const payload = {
    user_id: ownerId,
    feature: feature,
    attributes: {
      country: country,
      grow_id_last_digit: growIdLastDigit,
    },
  };

  return fetch(`${getApiUrl()}/api/ms/ab-proxy/treatment`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "api-key-sumer": getEnvVar("PUBLIC_API_KEY_SP"),
    } as { [key: string]: string },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => camelizeKeys(res) as Treatment);
};

export const fetchDisabledStores = (): Promise<string[]> => {
  return fetch(
    `${getApiUrl()}/api/ms/remote-config/country-data/store_banner_off`,
    {
      method: "GET",
      headers: {
        "api-key-sumer": getEnvVar("PUBLIC_API_KEY_SP") || "",
      },
    },
  )
    .then((res) => res.json())
    .then((res) => camelizeKeys(res).value.valid as string[])
    .catch(() => []);
};
